import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from "react-redux";
import {Box, Grid, Button, Divider} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {DateFormatter, MoneyFormatter} from "../../shared/formatter";
import {DashboardStyles} from "../../styles/dashboard";

const useStyles = makeStyles(DashboardStyles);

const AppointmentDetailBox = (props) => {

    const classes = useStyles();
    const history = useHistory();
    let appointments;

    appointments = props.vehicle ? props.vehicle.appointments : null;
    if (appointments && appointments.length) {
        if (props.account.location && props.account.location.timezone) {
            DateFormatter.timezone = props.account.location.timezone;
        }
        const buttonClickHandler = (event, appointment) => {
            history.push('/dashboard/appointments/' + appointment.id);
        };
        return (
            <Grid container justify='space-between' spacing={1}> 
                {appointments.map((appointment, idx) => {
                    const divider = idx+1 < appointments.length ? (
                        <Grid item xs={12} className={classes.dividerGrid}>
                                <Divider className={[ classes.divider ].join(' ')} />
                        </Grid>
                    ) : null;

                    return (
                        <React.Fragment key={idx}>
                            <Grid xs item>
                                <Box className={[classes.appointmentTypeBox, classes.colorBlue].join(' ')}
                                >Sell Vehicle</Box>
                                <Box className={classes.appointedAtBox}>
                                    {DateFormatter.stringDbDate2LongStringDate(appointment.appointedAt)}
                                    <br/>
                                    {DateFormatter.stringDbDate2StringTime(appointment.appointedAt)} {props.account.location.timezone_name}
                                </Box>
                            </Grid>
                            <Grid item zeroMinWidth className={classes.appointmentDetailsButtonBox}>
                                <Button variant='contained' color='primary' size='medium'
                                        onClick={(event) => buttonClickHandler(event, appointment)}
                                >DETAILS</Button>
                            </Grid>
                            {divider}
                        </React.Fragment>
                    );
                })}
            </Grid>
        )
    } else {
        return <React.Fragment>
            <Box>Scheduled appointments will appear here, please check back soon!</Box>
        </React.Fragment>
    }
}

const mapStateToProps = state => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps)(AppointmentDetailBox);